var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('connection-opened',{attrs:{"channel":_vm.publicChannel}}),_vm._v(" "),_c('connection-closed',{attrs:{"channel":_vm.publicChannel}}),_vm._v(" "),_c('message-created',{attrs:{"channel":_vm.privateChannel}}),_vm._v(" "),(_vm.subscribed)?_vm._t("default"):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e7eca83","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/live-coach-call/with-pusher-subscription/with-pusher-subscription.vue
// module id = Yx4a
// module chunks = 1